import {get} from '../utils'

export default host => (token) =>
  get(`${host}/webhooks/paypal?token=${token}`)
    .then(response => response.json())
    .then(json => json.data)
